import {FormDefinition} from "../../lib/forms";

export const getFormDefFazenda = (): FormDefinition => ({
  matriz: {name: 'matriz', label: 'Cliente tem PI', type: "boolean"},
  tipo: {name: 'tipo', label: 'Tipo de fazenda', type: "checkbox", required: true},
  responsavel: {name: 'responsavel', label: 'Responsável', type: "select", required: true},
  veterinario: {name: 'veterinario', label: 'Veterinário(s)', type: "select-multiple", required: false},
  // proprietario: {name: 'proprietario', label: 'Proprietário', type: "string", required: false},
  gerente: {name: 'gerente', label: 'Gerente', type: "string", required: false},
  designacao: {name: 'designacao', label: 'Designação', type: "select", required: false},
  nome: {name: 'nome', label: 'Nome da fazenda', type: "string", required: true},
  telefone: {name: 'telefone', label: 'Telefone', type: "telefone", required: true},
  email: {name: 'email', label: 'Email', type: "email", required: false},
  cidade: {name: 'cidade', label: 'Cidade', type: "searchInput", required: true},
  estado: {name: 'estado', label: 'Estado', type: "searchInput", required: true},

  latitude: {name: 'latitude', label: 'Latitude', type: "string", required: false},
  longitude: {name: 'longitude', label: 'Longitude', type: "string", required: false},

  tem_calendario_sanitario: {name: 'tem_calendario_sanitario', label: 'Tem calendário sanitário', type: "boolean"},

  sistema_producao: {name: 'sistema_producao', label: 'Sistema de produção Corte', type: "checkbox", required: false},
  sistema_producao_leite: {name: 'sistema_producao_leite', label: 'Sistema de produção Leite', type: "select", required: false},

  possui_estacao_monta: {name: 'possui_estacao_monta', label: 'Possui estação de monta', type: "boolean"},
});